export default "__VITE_ASSET__Rw9w9ZFm__"